






import { Prop, Vue, Component, Watch } from "vue-property-decorator";

@Component({
    name: "UE",
})
export default class UE extends Vue {
    @Prop()
    config?: object;
    @Prop()
    id?: string;
    @Prop({ default: "" }) value?: string;

    editor: any = null;

    mounted() {
        this.$nextTick(() => {
            if (!this.id) {
                this.id = new Date().getTime().toString();
            }

            // 动态加载 UEditor 和插件
            this.loadUEditor();
        });
    }

    async loadUEditor() {
        // 动态加载自定义插件
        await this.loadScript("UE/plugins/formcomponents.js");

        // 初始化 UEditor
        this.editor = (window as any).UE.getEditor(this.id, this.config);

        this.editor.addListener("ready", () => {
            this.editor.setContent(this.value); // 确保UE加载完成后，放入内容
            this.editor.addListener("contentChange", () => {
                this.$emit("ueditorContent", this.editor.getContent()); // 内容变化触发事件
                this.$emit("ueditorContentText", this.editor.getContentTxt()); // 纯文本内容
            });
        });
    }

    /**
     * 加载自定义插件
     * @param src 插件文件路径
     */
    loadScript(src: string) {
        return new Promise((resolve, reject) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = resolve;
            script.onerror = reject;
            document.head.appendChild(script);
        });
    }

    getUEContent() {
        return this.editor.getContent();
    }

    getUEContentText() {
        return this.editor.getContentTxt();
    }

    destroyed() {
        if (this.editor) {
            this.editor.destroy();
        }
    }

    @Watch("value")
    watchValueChange(val: string) {
        if (this.editor) {
            this.editor.setContent(val);
        }
    }

    execUECommand(str: string) {
        if (this.editor) {
            this.editor.execCommand("inserthtml", str);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ueditor/index.vue